import { Backdrop, Fade, Modal } from "@mui/material"
import { Dispatch, ReactNode, SetStateAction } from "react"

export default function ModalBase({
    children,
    open,
    modalId,
    setShowSelect,

}: {
    children: ReactNode,
    open: boolean,
    modalId: string,
    setShowSelect?: Dispatch<SetStateAction<boolean>>,
}) {
    return (
        <Modal
            open={open}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            id={modalId}
            slotProps={{
            backdrop: {
                timeout: 500,
            },
            }}
        >
            <Fade in={open} onEntered={setShowSelect ? () => setShowSelect(true) : undefined}>
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: '5rem',
                    width: '100%'
                }}
                >
                    {children}
                </div>
            </Fade>
        </Modal>
    )
}